var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.25) translate(-24.5 -27.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 35H104C110.2 35 114 39.3 114 45V84C114 90 110 93 104 93H95V116.5L72 93H40C34 93 31 89.5 31 84V44C31 38.6 34.6 35 40 35Z",
    stroke: "currentColor",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.5 43 L 65.5 44 L 65.5 46 L 62.5 50 L 61.5 49 L 57.5 49 L 54.5 52 L 52.5 56 L 52.5 60 L 55.5 63 L 55.5 64 L 52.5 67 L 52.5 71 L 54.5 75 L 57.5 78 L 61.5 78 L 62.5 77 L 64.5 79 L 65.5 81 L 65.5 83 L 67.5 84 L 76.5 84 L 78.5 82 L 78.5 80 L 81.5 77 L 82.5 78 L 86.5 78 L 89.5 75 L 91.5 71 L 91.5 67 L 88.5 64 L 88.5 63 L 91.5 60 L 91.5 56 L 89.5 52 L 86.5 49 L 82.5 49 L 81.5 50 L 78.5 47 L 78.5 45 L 76.5 43 Z M 70.5 47 L 73.5 47 L 75.5 51 L 77.5 53 L 79.5 54 L 83.5 54 L 84.5 53 L 86.5 56 L 86.5 58 L 84.5 60 L 84.5 67 L 86.5 69 L 86.5 71 L 84.5 74 L 83.5 73 L 79.5 73 L 77.5 74 L 75.5 76 L 73.5 80 L 70.5 80 L 68.5 78 L 68.5 76 L 64.5 73 L 60.5 73 L 59.5 74 L 56.5 70 L 59.5 66 L 59.5 61 L 56.5 57 L 59.5 53 L 60.5 54 L 64.5 54 L 66.5 53 L 68.5 51 L 68.5 49 Z M 66.5 57 L 64.5 60 L 64.5 67 L 65.5 69 L 68.5 71 L 75.5 71 L 79.5 67 L 79.5 60 L 75.5 56 L 68.5 56 Z M 68.5 62 L 70.5 60 L 73.5 60 L 75.5 62 L 75.5 65 L 73.5 67 L 70.5 67 L 68.5 65 Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonPractice);
export default __webpack_public_path__ + "static/media/lesson-practice.aa79efa3760edf59c4bc5982f03694b1.svg";
export { ForwardRef as ReactComponent };